export enum SORT_CRATE {
    CREATED_AT_DESC = 'publishDate@desc',
    CREATED_AT_ASC = 'publishDate@asc',
    BOUGHT_BY_DESC = 'boughtBy@DESC',
}

export enum DATE_RANGE_CRATE {
    ALL_TIME = 'all',
    LAST_7_DAYS = 7,
    LAST_30_DAYS = 30,
    LAST_90_DAYS = 90,
}
